import { render, staticRenderFns } from "./DeliverableCard.vue?vue&type=template&id=bb24f90a&scoped=true&"
import script from "./DeliverableCard.vue?vue&type=script&lang=js&"
export * from "./DeliverableCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableCard.vue?vue&type=style&index=0&id=bb24f90a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb24f90a",
  null
  
)

export default component.exports